var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFiremapSymbolAirbase = function SvgFiremapSymbolAirbase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0m2 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10m-11.996 2.1-.246-.671H8.063l-.252.671H6.529L8.32 9.9h1.282l1.732 4.2zM8.41 12.518H9.43l-.504-1.372zM12.887 9.9v4.2H11.64V9.9zm3.17 4.2h1.414l-.85-1.372c.455-.258.706-.713.706-1.336 0-.953-.647-1.492-1.773-1.492h-1.96v4.2h1.247v-1.132h.659zm-1.216-2.091v-1.15h.713c.371 0 .587.203.587.569 0 .377-.216.581-.587.581z",
    clipRule: "evenodd"
  })));
};
export default SvgFiremapSymbolAirbase;